export const bannerImagesRopa = [
    'https://relojes-s-l.s3.us-west-1.amazonaws.com/ROPA/Supreme+clasica+negra+1.JPEG',
    'https://relojes-s-l.s3.us-west-1.amazonaws.com/ROPA/Supreme+clasica+beige+1.JPEG',
    'https://relojes-s-l.s3.us-west-1.amazonaws.com/ROPA/Supreme+x+Ducati+negra+1.JPEG'
]